import { InputSignal, ModelSignal, TemplateRef, Type } from '@angular/core';
import { INJECT_TYPE } from './constants';

// 1. Unwraps modern signals to their raw types
type UnwrapInputSignal<T> = T extends InputSignal<infer U>
  ? U
  : T extends ModelSignal<infer M>
    ? M
    : T;

// 2. Helper to determine if a property can be assigned a value (filters out methods)
type IsMethod<T> = T extends Function
  ? (T extends InputSignal<any> | ModelSignal<any> ? false : true)
  : false;

type IsReadonly<T, K extends keyof T> =
  (<G>() => G extends { [P in K]: T[P] } ? 1 : 2) extends
  (<G>() => G extends { -readonly [P in K]: T[P] } ? 1 : 2)
    ? false // It is mutable (Like a normal variable or legacy @Input)
    : true;  // It is readonly (Like a static configuration object)

export type ComponentInputs<C> = {
  [K in keyof C as K extends 'constructor' | `ng${string}`
    ? never
    : IsMethod<C[K]> extends true
      ? never
      : IsReadonly<C, K> extends true
        ? never
        : K
  ]?: UnwrapInputSignal<C[K]>;
};

// TODO: replace @Input with modern input signal
// Strict Signal-Only Rule (Ignores all normal variables and readonly properties entirely)
// export type StrictComponentInputs<C> = {
//   [K in keyof C as C[K] extends InputSignal<any> | ModelSignal<any> ? K : never]?: UnwrapInputSignal<C[K]>;
// };

export class DialogItem<T = any> {
	constructor(
		public content: Type<T> | TemplateRef<any>,
		public data?: ComponentInputs<T>,
		public injectType: number = INJECT_TYPE.COMPONENT
	) {}
}
